/**
 * Builds the comma-joined query segment for a list of add-on tests, e.g.
 *   ["8600", { displayTestCode: "24001", code: "CCLA-24001-P75-1" }]
 * becomes
 *   "test=8600,test=24001&ctc=CCLA-24001-P75-1"
 * The result does NOT include a leading separator; callers prefix it as needed.
 */
export var buildAddOnTestsQuery = function buildAddOnTestsQuery(addOnTests) {
  return addOnTests.map(function (addOn) {
    return typeof addOn === "string" ? "test=".concat(addOn) : "test=".concat(addOn.displayTestCode, "&ctc=").concat(addOn.code);
  }).join(",");
};